import { useState, useRef, useEffect } from 'react'
import { Button, Form, Label, Input, Alert, Modal, ModalHeader, ModalBody, Row, Col, ModalFooter } from 'reactstrap'
import { gql } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { deepCopy, handleGraphQLErrors } from '../../utils'
import { AUTHORIZE_MUTATION } from '../../graphql.js'

const AUTHORIZE =  gql(AUTHORIZE_MUTATION)

export default function QRCode(props) {
  console.log('QRCode rendered: ', props)
  let { userId, qrCode, modal, toggle, setQRCodeComponent } = props

  const [authorizeMutation] = useMutation(AUTHORIZE)
  const [qrCodeError, setQrCodeError] = useState()
  const [qrCodeSuccess, setQrCodeSuccess] = useState(false)
  const [mfaInput, setmfaInput] = useState({ mfaCode: '' })

  // set the cursor to the "Code" input field
  const inputRef = useRef(null)
  useEffect(() => {
    console.log('QRCode.userEffect: ', inputRef)
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])

  function handleMfaInputChange(event, checkbox) {
    const newMfa = deepCopy(mfaInput)
    if (checkbox) {
      newMfa[event.target.name] = event.target.checked ? 'Y' : 'N'
    } else {
      newMfa[event.target.name] = event.target.value
    }
    setmfaInput(newMfa)
    return true
  }

  function handleKeyDown(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      submitQRCode()
    }
  }

  async function submitQRCode() {
    console.log('QRCode.submitQRCode: ', mfaInput.mfaCode)
    try {
      await authorizeMutation({ variables: { userId: userId, mfaCode: mfaInput.mfaCode, saveDevice: 'N', method: 'APP' } })
        .then((res) => {
          console.log('QRCode.submitQRCode:', res)
          if (res.data.authorize === 'SUCCESS') {
            setQrCodeSuccess(true)
            setQrCodeError(null)
          }
        })
    } catch (err) {
      handleGraphQLErrors(err, setQrCodeError)
      setQrCodeSuccess(false)
    }
  }

  function closeModal() {
    toggle()
    setQRCodeComponent(null)
  }

  let alert = ''
  if (qrCodeError) {
    alert = <Alert color="danger">{qrCodeError[0].message}</Alert>
  }
  if (qrCodeSuccess) {
    alert = <Alert color="success">Authenticator code verified.</Alert>
  }

  return (
    <Modal isOpen={modal} backdrop='static' toggle={closeModal}>
      <ModalHeader>Scan QR Code</ModalHeader>
      <ModalBody>
        {alert}
        <p style={{ fontWeight: 'bold', textAlign: 'left' }}>Scan this QR Code using the Authenticator app on your mobile device. Then enter the code that you see in the app into the "Authenticator Code" field and click the "Verify Code" button.</p>
        <img alt="QR Code" src={qrCode} />
        <Form style={{ marginTop: '20px' }} > 
          <Row className="row-cols-lg-auto g-3 align-items-center">
            <Col>
              <Label for="mfaCode" style={{ float: 'left', marginBottom: '0rem' }}>Authenticator Code</Label>
            </Col>
            <Col>
              <Input innerRef={inputRef} name="mfaCode" id="mfaCode" onChange={handleMfaInputChange} onKeyDown={handleKeyDown} style={{ width: '100px' }} />
            </Col>
            <Col>
              <Button color="secondary" onClick={submitQRCode}>Verify Code</Button>
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={closeModal} >Close</Button>
      </ModalFooter>
    </Modal>
  )
}